





































































































































































































































































































































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import FormInput from '@/components/FormInput.vue';
import FileInput from '@/components/FileInput.vue';
import api from '@/libs/api';
import {
  MerchantsManagement, ProvinceList, CityList, DistrictList,
} from '@/libs/api.interfaces';
import Toggle from '@/components/Toggle.vue';
// import axios from 'axios';
import Select from '@/components/Select.vue';
import Button from '@/components/Button.vue';
import CloseIcon from 'mdi-vue/Close';
import InformationIcon from 'mdi-vue/InformationOutline';
// eslint-disable-next-line import/no-cycle
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import numberFormat from '@/libs/numberFormat';
import { ValidationObserver } from 'vee-validate';
import Modal from '@/components/Modal.vue';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
    Select,
    FormInput,
    Button,
    Modal,
    CloseIcon,
    InformationIcon,
    Toggle,
    FileInput,
  },
  methods: {
    numberFormat,
  },
})

export default class MerchantAdd extends Vue {
  data!: MerchantsManagement;
  loading = false;
  merchantName = '';
  country = 'Indonesia';
  toggleStatus = false;
  showModal = false;
  modalImage = '';
  brandName = '';
  bankBranch = '';
  bankAccountName = '';
  phoneNumber = '';
  merchantLogo = '';
  merchantURLPage = '';
  postalCode = '';
  npwpAddress = '';
  address = '';
  merchantBrand = '';
  MCC: any = '';
  paymentFlag = '';
  faxNumber = '';
  customerType = '';
  npwpNumber = '';
  bankName = '';
  picBusinessFullName = ''
  picBusinessEmail = '';
  picBusinessPhoneNumber = '';
  pictechnicalFullName = '';
  picBtechnicalEmail = '';
  pictechnicalPhoneNumber = '';
  picFinanceFullName = ''
  picFinanceEmail = '';
  picFinancePhoneNumber = '';
  merchantPanelAccount = '';
  merchantPanelName = '';
  merchantPanelEmail = '';
  websiteName = '';
  MerchantPanelPhoneNumber = '';
  notificationEmail: { value: string }[] = [];
  dailyReport: { value: string }[] = [];
  settlementReport: { value: string }[] = [];
  status = '';
  merchantNPWP = '';
  merchantSIUP = '';
  merchantTDP = '';
  directorIdentityCard = '';
  directorName = '';
  directorIdentityCardNumber = '';
  directorNPWP = '';
  directorNPWPNumber = '';
  aktaPendirian = '';
  SK = '';
  merchantLogoName = '';
  merchantNPWPName = '';
  merchantSIUPName = '';
  MerchantTDPName = '';
  directorIdentityCardName = '';
  aktaPendirianName = '';
  SKName = '';
  directorNPWPName = '';
  province: { id?: number } | null = null;
  // province: { id: number }[] = [];
  provinceList: { id: number; country_id: number; name: string }[] = [];
  // city: { id: number }[] = [];
  city: { id?: number } | null = null;
  citylist: { id: number; name: string }[] = [];
  // district: { id: number }[] = [];
  district: { id?: number } | null = null;
  subDistrict: { id?: number; postalCode: string } | null = null;
  districtlist: { id: number; name: string }[] = [];
  subDistrictlist: { id: number; name: string; postalCode: string }[] = [];

  loadingCountry = false;
  loadingProvince = false;
  loadingCity = false;
  loadingDistrict = false;
  loadingSubDistrict = false;
  categoryCodes: { label: string; value: number }[] = [];
  emailTechnicalTaken = ''
  emailBusinessTaken = ''
  trafficAverageOption = [
    { id: 1, label: '< 25' },
    { id: 2, label: '25 - 100' },
    { id: 3, label: '100 - 700' },
    { id: 4, label: '700+' },
  ];

  amountAverageOption = [
    { id: 1, label: '< 200K IDR' },
    { id: 2, label: '200 - 500K IDR' },
    { id: 3, label: '500 - 1500K IDR' },
    { id: 4, label: '1500K IDR+' },
  ];

  transactionTrafficAverage: any = [];
  transactionAmountAverage: any = [];
  bankList: any = [];

  async getMCC() {
    try {
      this.loading = true;
      const { data } = await api.get('/getMCC');
      this.categoryCodes = data.map((e: any) => ({
        label: e.category_name,
        value: e.category_code,
      }));
      // if (!this.MCC) {
      //   this.MCC = this.categoryCodes.find((e) => e.value === Number(this.data.merchant_mcc) || null);
      // }
      this.loading = false;
    } catch (err) {
      console.error(err);
    }
  }

  handleFileName(val: [string, string]) {
    this.loading = false;
    if (val[0] === 'merchantLogo') {
      this.merchantLogo = val[1].toString();
    } else if (val[0] === 'directorIdentityCard') {
      this.directorIdentityCard = val[1].toString();
    } else if (val[0] === 'directorNPWP') {
      this.directorNPWP = val[1].toString();
    } else if (val[0] === 'aktaPendirian') {
      this.aktaPendirian = val[1].toString();
    } else if (val[0] === 'merchantNPWP') {
      this.merchantNPWP = val[1].toString();
    } else if (val[0] === 'merchantSIUP') {
      this.merchantSIUP = val[1].toString();
    } else if (val[0] === 'SK') {
      this.SK = val[1].toString();
    } else if (val[0] === 'merchantTDP') {
      this.merchantTDP = val[1].toString();
    }
  }

  async getProvince() {
    try {
      this.loading = false;
      this.loadingProvince = true;
      const { data } = await api.get<ProvinceList[]>('/countries', {
        params: {
          id: 1,
        },
      });
      this.provinceList = data[0].provinces.map((e) => ({
        id: e.id,
        // eslint-disable-next-line @typescript-eslint/camelcase
        country_id: Number(e.country_id),
        name: e.name,
      }));
      this.loadingProvince = false;
    } catch (err) {
      console.error(err);
    }
  }

  showImage(val: any) {
    console.log(this.merchantLogo);
    if (val) {
      this.showModal = true;
      this.modalImage = val;
    } else {
      // this.$refs.fileInput.click();
    }
  }

  async getCity() {
    if (this.province === null) return;
    this.loadingCity = true;
    try {
      this.loading = false;
      const { data } = await api.get<CityList[]>('/provinces', {
        params: {
          id: this.province.id,
        },
      });
      this.citylist = data[0].cities.map((e) => ({
        id: e.id,
        name: e.name,
      }));
      this.loadingCity = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getdistrict() {
    if (this.city === null) return;
    try {
      this.loadingDistrict = true;
      this.loading = false;
      const { data } = await api.get<DistrictList[]>('/cities', {
        params: {
          id: this.city.id,
        },
      });
      this.districtlist = data[0].districts.map((e) => ({
        id: e.id,
        name: e.name,
      }));
      this.loadingDistrict = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getSubdistrict() {
    if (this.district === null) return;
    try {
      this.loadingSubDistrict = true;
      this.loading = false;
      const { data } = await api.get('/districts', {
        params: {
          id: this.district.id,
        },
      });
      this.subDistrictlist = data[0].sub_districts.map((e: any) => ({
        id: e.id,
        name: e.name,
        postalCode: e.zip_code,
      }));
      this.loadingSubDistrict = false;
    } catch (err) {
      console.error(err);
    }
  }

  NumberOnly() {
    const isNumber = /[\d]/g;
    if (!isNumber.test(this.npwpNumber)) {
      this.npwpNumber = '';
    }
    // this.npwpNumber = 'lalala';
  }

  async getPostalCode() {
    if (this.subDistrict !== null) {
      console.log(this.subDistrict.postalCode);
      this.postalCode = this.subDistrict.postalCode;
    }
  }

  mounted() {
    this.getProvince();
    this.getMCC();
    this.getBanks();
  }

  @Watch('province')
  async provinceChange() {
    this.getCity();
  }

  @Watch('city')
  async cityChange() {
    this.getdistrict();
  }

  @Watch('district')
  async districtChange() {
    this.getSubdistrict();
  }

  @Watch('subDistrict')
  async subDistrictChange() {
    this.getPostalCode();
  }

  cancel() {
    this.$router.push('/account-management');
  }

  async addMerchant() {
    // if (this.province === null) return;
    // if (this.city === null) return;
    // if (this.district === null) return;
    try {
      this.loading = true;

      await api.post('/consumer/merchant', {
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_logo: this.merchantLogo,
        web_url: this.websiteName,
        payment_flag_url: this.paymentFlag,
        need_approval: '1',
        merchant_phone: this.phoneNumber,
        merchant_name: this.merchantName,
        merchant_brand: this.merchantBrand,
        merchant_address: this.address,
        merchant_npwp: this.npwpNumber,
        merchant_npwp_address: this.address,
        merchant_rekening: '871827635',
        trx_amount: this.transactionAmountAverage.id,
        trx_traffic: this.transactionTrafficAverage.id,
        merchant_siup: this.merchantSIUP,
        merchant_tdp: this.merchantTDP,
        merchant_akta: this.aktaPendirian,
        merchant_sk: this.SK,
        merchant_npwp_img: this.merchantNPWP,
        merchant_mcc: this.MCC?.value,
        country: 1,
        province: this.province === null ? 0 : this.province.id,
        city: this.city === null ? 0 : this.city.id,
        district: this.district === null ? 0 : this.district.id,
        subdistrict: this.subDistrict === null ? 0 : this.subDistrict.id,
        postal_code: this.postalCode,
        fax_number: this.faxNumber,
        // email_notification: this.notificationEmail.map((e) => e.value),
        // email_daily_report: this.dailyReport.map((e) => e.value),
        // email_settlement_repot: this.settlementReport.map((e) => e.value),
        director_identity_card: this.directorIdentityCard,
        director_ktp_number: this.directorIdentityCardNumber,
        director_name: this.directorName,
        director_npwp: this.directorNPWP,
        director_npwp_number: this.directorNPWPNumber,
        pic_business_name: this.picBusinessFullName,
        pic_business_email: this.picBusinessEmail,
        pic_business_phone: this.picBusinessPhoneNumber,
        pic_technical_name: this.pictechnicalFullName,
        pic_technical_email: this.picBtechnicalEmail,
        pic_technical_phone: this.pictechnicalPhoneNumber,
        pic_finance_name: this.picFinanceFullName,
        pic_finance_email: this.picFinanceEmail,
        pic_finance_phone: this.picFinancePhoneNumber,
        bank_name: this.bankName,
        bank_branch: this.bankBranch,
        bank_account_name: this.bankAccountName,
        status: this.toggleStatus ? 'ACTIVE' : 'INACTIVE',
      });
      showToast(ToastType.SUCCESS, 'Success', 'Data berhasil tersimpan');
      this.$router.push('/account-management');
    } catch (err) {
      const error = err as any;
      if (error.response.data.error.errors.find((e: any) => e.message
        === 'The pic technical email has already been taken.')) {
        this.emailTechnicalTaken = error.response.data.error.errors.find((e: any) => e.message
          === 'The pic technical email has already been taken.').message;
      }
      if (error.response.data.error.errors.find((e: any) => e.message
        === 'The pic business email has already been taken.')) {
        this.emailBusinessTaken = error.response.data.error.errors.find((e: any) => e.message
          === 'The pic business email has already been taken.').message;
      }
      showToast(ToastType.FAILED, 'Oops… Sorry', error.response.data.error.errors.map((e: any) => e.message));
      this.loading = false;
    }
  }

  async getBanks() {
    try {
      const { data } = await api.get('/bank');
      const banks = data[0];
      this.bankList = Object.values(banks);
      console.log(this.bankList);
    } catch (err) {
      showToast(ToastType.FAILED, 'Error', 'Failed to load bank list');
    }
  }
}
